<template>
  <LayoutApplicationStyle>
    <div class="pp-wrap">
      <PostPurchaseSteps :current="3" />

      <section class="pp-hero">
        <div class="pp-kick">{{ copy.kick }}</div>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <h1 v-html="copy.title"></h1>
        <p class="pp-sub">{{ copy.sub(host) }}</p>

        <div class="pp-cal">
          <div
            v-if="url"
            ref="widget"
            class="calendly-inline-widget pp-cal-widget"
            :data-url="url"
          ></div>
          <div v-else class="pp-fallback">
            <p>{{ copy.fallback }}</p>
            <a href="tel:18443919499">1-844-391-9499</a>
            <a href="mailto:sales@bambee.com">sales@bambee.com</a>
          </div>
        </div>

        <div class="pp-later">
          <button class="pp-link" type="button" @click="finish('skipped')">
            {{ copy.later }}
          </button>
        </div>
      </section>
    </div>
  </LayoutApplicationStyle>
</template>

<script>
import { onBeforeUnmount, onMounted, ref } from '@nuxtjs/composition-api';
import LayoutApplicationStyle from '../LayoutApplicationStyle.vue';
import PostPurchaseSteps from '../PostPurchaseSteps.vue';
import {
  FounderCallEventUrl,
  FounderCallHost,
  Schedule,
} from '../../constants/PostPurchase';
import useRegistration, {
  RegistrationStateNames as R,
} from '../../hooks/useRegistration';
import track from '../../utils/postPurchaseTrack';

const WIDGET_SRC = 'https://assets.calendly.com/assets/external/widget.js';

/**
 * The founder installation call. The host and the Calendly event follow the level
 * (Observation books a Coverage Advisor, the rest a Chief of Staff). Booking, or
 * "I'll schedule later", is the last step: submitting completes registration and
 * sends the customer to app.
 */
export default {
  name: 'SchedulePage',
  components: { LayoutApplicationStyle, PostPurchaseSteps },
  setup(_, { emit }) {
    const { state } = useRegistration();
    const widget = ref(null);
    const level = state[R.SUPERVISION_LEVEL];
    const host = FounderCallHost[level] || FounderCallHost.supervision;
    const base = FounderCallEventUrl[level];

    // Prefill the way app's generateCalendlyURL does: name, email, custom answers
    // (a1 company, a2 phone) and company|user in utm_content for the webhook.
    const url =
      base &&
      `${base}?${new URLSearchParams({
        name: state[R.FULL_NAME] || '',
        email: state[R.EMAIL] || '',
        a1: state[R.COMPANY_NAME] || '',
        a2: state[R.PHONE] || '',
        utm_source: 'get',
        utm_content: `${state[R.COMPANY_ID]}|${
          state[R.USER_ID]
        }|founder-installation`,
      })}`;

    const finish = (how) => emit('submit', { [R.FOUNDER_CALL]: how });

    const onMessage = (e) => {
      if (e?.data?.event === 'calendly.event_scheduled') {
        track(state, 'founder-call-scheduled', {
          host,
          calendlyEvent: e.data.payload?.event?.uri,
        });
        finish('scheduled');
      }
    };

    onMounted(() => {
      track(state, 'schedule-viewed', { host, hasEventUrl: !!url });
      window.addEventListener('message', onMessage);
      if (!url) {
        return;
      }
      if (window.Calendly) {
        window.Calendly.initInlineWidget({ url, parentElement: widget.value });
      } else {
        // widget.js initialises every .calendly-inline-widget[data-url] on load.
        const script = document.createElement('script');
        script.src = WIDGET_SRC;
        script.async = true;
        document.body.appendChild(script);
      }
    });

    onBeforeUnmount(() => window.removeEventListener('message', onMessage));

    return { copy: Schedule, host, url, widget, finish };
  },
};
</script>
